import React from "react";
import about1Img from "../../../assets/Images/about/img_1.JPG";

const OurJourney_Banner = () => {
  return (
    <section className="relative w-full h-[300px] md:h-[500px] overflow-hidden">

      {/* Background Image */}
      <img
        src={about1Img}
        alt="Our Journey"
        className="absolute inset-0 w-full h-full object-cover"
      />

      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent"></div>

      {/* Content */}
      <div className="relative h-full max-w-7xl mx-auto px-4 sm:px-6 flex flex-col justify-end">

        {/* Title */}
        <h1 className="text-white text-2xl md:text-4xl font-semibold">
          Our Journey
        </h1>

        {/* Description */}
        <p className="text-gray-200 text-sm md:text-base mt-2 mb-6 max-w-xl leading-relaxed">
          The milestones, people, and decisions that have shaped Nutralike over the years.
        </p>

      </div>
    </section>
  );
};

export default OurJourney_Banner;
